function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { StateHandler, controllerMixin } from 'oskari-ui/util';
import { LayerListHandler } from './LayerList';
import { SelectedLayersHandler } from './SelectedLayers';
var ViewHandler = /*#__PURE__*/function (_StateHandler) {
  function ViewHandler(instance) {
    var _this;
    _classCallCheck(this, ViewHandler);
    _this = _callSuper(this, ViewHandler);
    _this.instance = instance;
    _this.sandbox = instance.getSandbox();
    _this.layerListHandler = _this._createLayerListHandler();
    _this.selectedLayersHandler = _this._createSelectedLayersHandler();
    _this.state = {
      layerList: {
        state: _this.layerListHandler.getState(),
        controller: _this.layerListHandler.getController()
      },
      selectedLayers: {
        state: _this.selectedLayersHandler.getState(),
        controller: _this.selectedLayersHandler.getController()
      },
      autoFocusSearch: true
    };
    _this.eventHandlers = _this._createEventHandlers();
    return _this;
  }
  _inherits(ViewHandler, _StateHandler);
  return _createClass(ViewHandler, [{
    key: "_createLayerListHandler",
    value: function _createLayerListHandler() {
      var _this2 = this;
      var handler = new LayerListHandler(this.instance);
      handler.addStateListener(function (layerListState) {
        return _this2.updateState({
          autoFocusSearch: false,
          layerList: {
            state: layerListState,
            controller: _this2.state.layerList.controller
          }
        });
      });
      return handler;
    }
  }, {
    key: "_createSelectedLayersHandler",
    value: function _createSelectedLayersHandler() {
      var _this3 = this;
      var handler = new SelectedLayersHandler(this.instance);
      handler.addStateListener(function (selectedLayersState) {
        _this3.updateState({
          selectedLayers: {
            state: selectedLayersState,
            controller: _this3.state.selectedLayers.controller
          }
        });
      });
      return handler;
    }
  }, {
    key: "getLayerListHandler",
    value: function getLayerListHandler() {
      return this.layerListHandler;
    }
  }, {
    key: "setTab",
    value: function setTab(tab) {
      this.updateState({
        autoFocusSearch: true,
        tab: tab
      });
    }

    /// Oskari event handling ////////////////////////////////////////////////////////////

    /**
     * "Module" name for event handling
     */
  }, {
    key: "getName",
    value: function getName() {
      return 'LayerViewTabsHandler';
    }
    /**
    * @method onEvent
    * @param {Oskari.mapframework.event.Event} event a Oskari event object
    * Event is handled forwarded to correct #eventHandlers if found or discarded if not.
    */
  }, {
    key: "onEvent",
    value: function onEvent(event) {
      var handler = this.eventHandlers[event.getName()];
      if (!handler) {
        return;
      }
      return handler.apply(this, [event]);
    }
  }, {
    key: "_createEventHandlers",
    value: function _createEventHandlers() {
      var _this4 = this;
      var updateSelectedLayers = function updateSelectedLayers() {
        return _this4.selectedLayersHandler.updateLayers();
      };
      var handlers = {
        'userinterface.ExtensionUpdatedEvent': function userinterfaceExtensionUpdatedEvent(event) {
          // ExtensionUpdateEvents are fired a lot, only let layerlist extension event to be handled when enabled
          if (event.getExtension().getName() !== _this4.instance.getName()) {
            // wasn't me -> do nothing
            return;
          }
          if (event.getViewState() === 'attach') {
            _this4.updateState({
              autoFocusSearch: true
            });
            return;
          }
          if (event.getViewState() === 'close') {
            var filterHandler = _this4.getLayerListHandler().getFilterHandler();
            if (filterHandler.hasStashedState()) {
              filterHandler.useStashedState();
            }
          }
        },
        'MapLayerEvent': function MapLayerEvent(event) {
          var layerId = event.getLayerId();
          if (['add', 'remove'].includes(event.getOperation()) && layerId) {
            // refresh layer list on add/remove when layerId is provided
            _this4.getLayerListHandler().updateState({});
            return;
          }
          if (!['update', 'sticky', 'tool'].includes(event.getOperation())) {
            return;
          }
          if (layerId) {
            var _this4$selectedLayers = _this4.selectedLayersHandler.getState(),
              layers = _this4$selectedLayers.layers;
            if (!layers.find(function (layer) {
              return layer.getId() === layerId;
            })) {
              return;
            }
          }
          updateSelectedLayers();
        },
        'MapLayerVisibilityChangedEvent': function MapLayerVisibilityChangedEvent(event) {
          return _this4.selectedLayersHandler.updateVisibilityInfo(event);
        },
        'AfterMapLayerRemoveEvent': updateSelectedLayers,
        'AfterMapLayerAddEvent': updateSelectedLayers,
        'AfterRearrangeSelectedMapLayerEvent': updateSelectedLayers,
        'AfterChangeMapLayerStyleEvent': updateSelectedLayers,
        'AfterChangeMapLayerOpacityEvent': updateSelectedLayers
      };
      Object.getOwnPropertyNames(handlers).forEach(function (p) {
        return _this4.sandbox.registerForEventByName(_this4, p);
      });
      return handlers;
    }
  }]);
}(StateHandler);
export var LayerViewTabsHandler = controllerMixin(ViewHandler, ['setTab']);